import React from "react"
import Carousel from "react-bootstrap/Carousel"
import scrollerStyles from "./scroller.module.scss"

const Scroller = () => {
  return (
    <section className={`col-lg-9 col-md-12 col-sm-12 col-xs-12 mx-auto px-0`}>
      <Carousel controls={false} indicators={false}>
        <Carousel.Item interval={2000}>
          <h2 className={`text-info text-center ${scrollerStyles.mainHeading}`}>
            Web <br /> Applications
          </h2>
        </Carousel.Item>
        <Carousel.Item interval={2000}>
          <h2 className={`text-info text-center ${scrollerStyles.mainHeading}`}>
            Mobile APP <br /> Development
          </h2>
        </Carousel.Item>
        <Carousel.Item interval={2000}>
          <h2 className={`text-info text-center ${scrollerStyles.mainHeading}`}>
            API's using <br /> NodeJS
          </h2>
        </Carousel.Item>
        <Carousel.Item interval={2000}>
          <h2 className={`text-info text-center ${scrollerStyles.mainHeading}`}>
            UI and UX <br /> Development
          </h2>
        </Carousel.Item>
      </Carousel>
    </section>
  )
}

export default Scroller
